import {
  LuCode,
  LuHelpCircle,
  LuLightbulb,
  LuRocket,
  LuSearch,
  LuUsers,
} from 'react-icons/lu';

export const features = [
  {
    icon: <LuSearch size={48} />,
    title: 'Smart Repository Explorer',
    description:
      'Navigate your codebase with ease, uncovering connections and insights you never knew existed.',
  },
  {
    icon: <LuHelpCircle size={48} />,
    title: 'Contextual Q&A Engine',
    description:
      'Get instant, accurate answers to your code-related questions, boosting productivity and understanding.',
  },
  {
    icon: <LuLightbulb size={48} />,
    title: 'Knowledge Discovery',
    description:
      'Illuminate hidden patterns and insights in your codebase, driving innovation and problem-solving.',
  },
  {
    icon: <LuUsers size={48} />,
    title: 'Collaborative Learning',
    description:
      'Foster a culture of shared knowledge and continuous improvement, empowering your entire team.',
  },
  {
    icon: <LuCode size={48} />,
    title: 'Codebase Understanding',
    description:
      'Gain deep insights into your existing codebase, making it easier to understand, maintain, and enhance.',
  },
  {
    icon: <LuRocket size={48} />,
    title: 'Onboarding Accelerator',
    description:
      'Rapidly integrate new team members, enabling them to contribute effectively from day one.',
  },
];
